// extracted by mini-css-extract-plugin
export default {"indicatorCaptionContent":"indicatorCaptionContent__3eV9X"};